/* Palmekongen · UX-lag (okt 2026): købsbjælke på produktsiden og genveje i mobilmenuen */
(function () {
  'use strict';

  /* ---------- Købsbjælke: vises på mobil, når den rigtige købsknap er ude af syne ---------- */
  function koebsbjaelke() {
    if (!document.body.classList.contains('template-product')) return;
    var knap = document.querySelector('.product-form__submit');
    if (!knap || !('IntersectionObserver' in window)) return;
    var titelEl = document.querySelector('.product__title h1, h1.product__title, .product__title');
    var navn = titelEl ? titelEl.textContent.trim().split(/\s[–-]\s/)[0] : '';

    var bar = document.createElement('div');
    bar.className = 'pk-koeb';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Køb ' + navn);
    bar.innerHTML = '<div class="pk-koeb__info"><span class="pk-koeb__navn"></span><span class="pk-koeb__valg"></span></div>' +
      '<button type="button" class="pk-koeb__knap">Læg i kurven</button>';
    bar.querySelector('.pk-koeb__navn').textContent = navn;
    document.body.appendChild(bar);
    var valgEl = bar.querySelector('.pk-koeb__valg'), bKnap = bar.querySelector('.pk-koeb__knap');

    function pris() {
      var box = knap.closest('.product__info-container, .product__info-wrapper, product-info, section') || document;
      var el = box.querySelector('.price__sale:not(.hidden) .price-item--sale, .price__regular .price-item--regular, .price-item--last, .price-item');
      if (!el) return '';
      return el.textContent.replace(/\s+/g, ' ').replace(/,00/, '').replace(/\s?(kr\.?|DKK)\s*$/i, '').trim() + ' kr.';
    }
    function stoerrelse() {
      var r = document.querySelector('variant-radios input[type=radio]:checked, variant-selects input[type=radio]:checked, .product-form__input input[type=radio]:checked');
      if (r) return r.value.replace(/(\d)\s*-\s*(\d)/g, '$1–$2');
      var s = document.querySelector('variant-selects select, .product-form__input select');
      return s ? s.value : '';
    }
    function opdater() {
      var st = stoerrelse(), p = pris();
      valgEl.textContent = [st, p].filter(Boolean).join(' · ');
      bKnap.disabled = !!knap.disabled;
      bKnap.textContent = knap.disabled ? 'Udsolgt' : 'Læg i kurven';
    }
    opdater();
    document.addEventListener('change', function (e) { if (e.target.closest('variant-radios, variant-selects, .product-form__input')) setTimeout(opdater, 350); });
    new MutationObserver(function () { opdater(); }).observe(knap, { attributes: true, childList: true, subtree: true });

    bKnap.addEventListener('click', function () { if (!knap.disabled) knap.click(); });

    var synlig = true, footerSynlig = false;
    function vis() {
      var on = !synlig && !footerSynlig;
      bar.classList.toggle('er-vist', on);
      document.body.classList.toggle('pk-koeb-vist', on);
    }
    new IntersectionObserver(function (es) { synlig = es[0].isIntersecting; vis(); }, { threshold: 0 }).observe(knap);
    var footer = document.querySelector('.footer, footer');
    if (footer) new IntersectionObserver(function (es) { footerSynlig = es[0].isIntersecting; vis(); }).observe(footer);
  }

  /* ---------- Mobilmenu: genveje til palmesimulator og rådgivning, og personlig kontakt ---------- */
  function menuEkstra() {
    var nav = document.querySelector('#menu-drawer .menu-drawer__navigation');
    if (!nav || document.querySelector('.pk-menu-ekstra')) return;
    var box = document.createElement('div');
    box.className = 'pk-menu-ekstra';
    box.innerHTML =
      '<p class="pk-menu-ekstra__titel">Find den rigtige palme</p>' +
      '<ul class="pk-menu-ekstra__genveje" role="list">' +
        '<li><a href="/pages/se-palmen-i-din-have"><b>Palmesimulatoren</b><small>Se palmen i dit eget foto</small></a></li>' +
        '<li><a href="/pages/raadgivning"><b>Rådgivning</b><small>Personlig hjælp og havedesign</small></a></li>' +
      '</ul>' +
      '<p class="pk-menu-ekstra__kontakt">Spørg palmekongen: <a href="tel:+4531330552">31 33 05 52</a></p>';
    nav.insertAdjacentElement('afterend', box);
  }

  /* ---------- Kategorier: overskrift, genveje med den aktuelle markeret, og "Alle" sorteret efter bedst sælgende ---------- */
  var KAT = [
    ['Alle', 'Alle planter', '/collections/all'],
    ['Udendørs', 'Udendørs palmer', '/collections/udendors-palmer'],
    ['Indendørs', 'Indendørs palmer', '/collections/indendors-palmer'],
    ['Vinterhårdføre', 'Vinterhårdføre palmer', '/collections/vinterhaardfoere-palmer'],
    ['Oliven & citrus', 'Oliven & citrus', '/collections/middelhavsplanter'],
    ['Pleje & tilbehør', 'Pleje & tilbehør', '/collections/pleje-og-tilbehoer']
  ];
  function alleSorteret() {
    document.querySelectorAll('a[href="/collections/all"], a[href="https://palmekongen12.shop/collections/all"]').forEach(function (a) { a.setAttribute('href', '/collections/all?sort_by=best-selling'); });
  }
  function kategoriGenveje() {
    if (!document.body.classList.contains('template-collection') || document.querySelector('.pk-kat')) return;
    var grid = document.querySelector('#ProductGridContainer');
    var holder = grid && grid.closest('.section--padding');
    if (!holder) return;
    var sti = location.pathname.replace(/\/$/, '');
    var aktiv = KAT.filter(function (k) { return k[2] === sti; })[0];
    var harTitel = Array.prototype.some.call(document.querySelectorAll('main h1'), function (h) { return h.offsetParent; });
    var box = document.createElement('div');
    box.className = 'pk-kat page-width';
    var html = '';
    if (!harTitel) {
      var titel = aktiv ? aktiv[1] : document.title.split(/\s[–|-]\s/)[0];
      html += '<h1 class="pk-kat__titel"></h1>';
      box.dataset.titel = titel;
    }
    html += '<nav aria-label="Kategorier"><ul class="pk-kat__genveje" role="list">' + KAT.map(function (k) {
      var href = k[2] === '/collections/all' ? '/collections/all?sort_by=best-selling' : k[2];
      return '<li><a href="' + href + '"' + (aktiv === k ? ' aria-current="page"' : '') + '>' + k[0].replace('&', '&amp;') + '</a></li>';
    }).join('') + '</ul></nav>';
    box.innerHTML = html;
    if (box.dataset.titel) box.querySelector('h1').textContent = box.dataset.titel;
    holder.insertBefore(box, holder.firstChild);
    var cur = box.querySelector('[aria-current="page"]');
    if (cur) cur.parentElement.parentElement.scrollLeft = cur.parentElement.offsetLeft - 16;
  }

  /* ---------- Instagram: overskrift og følg-knap over feedet ---------- */
  function instagram() {
    var blok = document.querySelector('[id*="instafeed_app_block"]');
    if (!blok || document.querySelector('.pk-ig')) return;
    var profil = 'https://www.instagram.com/palmekongen12.shop';
    var top = document.createElement('div');
    top.className = 'pk-ig';
    top.innerHTML = '<div><p class="pk-ig__kicker"><a href="' + profil + '" target="_blank" rel="noopener">@palmekongen12.shop</a></p>' +
      '<h2 class="pk-ig__titel h1">Palmer, der <em>har slået rødder</em></h2>' +
      '<p class="pk-ig__tekst">Haver, terrasser og stuer, hvor vores palmer er flyttet ind.</p></div>' +
      '<a class="button button--secondary" href="' + profil + '" target="_blank" rel="noopener">Følg os på Instagram</a>';
    blok.parentNode.insertBefore(top, blok);
  }


  /* ---------- Ø i overskriftsfonten: glyffen har for bred afstand efter sig, så den strammes op ---------- */
  function oe(root) {
    if (!document.createTreeWalker) return;
    var w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, { acceptNode: function (n) {
      if (!/[øØ]/.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
      var p = n.parentElement;
      if (!p || p.closest('script,style,textarea,input,select,option,.pk-oe')) return NodeFilter.FILTER_REJECT;
      return /PK Overskrift/.test(getComputedStyle(p).fontFamily) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
    } });
    var ns = []; while (w.nextNode()) ns.push(w.currentNode);
    ns.forEach(function (n) {
      var f = document.createDocumentFragment();
      n.nodeValue.split(/([øØ])/).forEach(function (t) {
        if (!t) return;
        if (t === 'ø' || t === 'Ø') { var sp = document.createElement('span'); sp.className = 'pk-oe'; sp.textContent = t; f.appendChild(sp); }
        else f.appendChild(document.createTextNode(t));
      });
      n.parentNode.replaceChild(f, n);
    });
  }

  function start() { koebsbjaelke(); menuEkstra(); alleSorteret(); kategoriGenveje(); instagram(); oe(); setTimeout(function () { oe(); }, 1500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
